import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateCompanyProfileDetailsRequest extends BaseUpdateRequest {
    brandName: string;
    website: string;
    biography: string;
}